import { Stack, Typography, Container } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import EmailTemplates from '../sections/email-templates';

const MessageView = () => {
  const settings = useSettingsContext();

  return (
    <Container
      sx={{
        py: '42.5px',
        px: '40px',
      }}
      maxWidth={settings.themeStretch ? false : 'lg'}
    >
      <Stack
        sx={{
          gap: '40px',
        }}
      >
        <Typography variant="h2" fontWeight={600}>
          Automated Email
        </Typography>
        <EmailTemplates />
      </Stack>
    </Container>
  );
};

export default MessageView;
